import React from "react";
import { SectionHeading, Spinner } from "@vwfs-bronson/bronson-react";

class SpinnerSection extends React.Component<SpinnerProps> {
  render() {
    return (
      <section className="o-content-section u-m-xlarge">
        <div className="o-page-wrap">
          {this.props.heading && (
            <SectionHeading
              level={3}
              center
              subtitle={this.props.subtitle}
            >
              {this.props.heading}
            </SectionHeading>
          )}
          <Spinner section center/>
        </div>
      </section>
    );
  }
}

type SpinnerProps = {
  heading?: string;
  subtitle?: string;
};

export { SpinnerSection };
